import { render, staticRenderFns } from "./UserLikeReplyModal.vue?vue&type=template&id=c2f75bf8&scoped=true&"
import script from "./UserLikeReplyModal.vue?vue&type=script&lang=js&"
export * from "./UserLikeReplyModal.vue?vue&type=script&lang=js&"
import style0 from "./UserLikeReplyModal.vue?vue&type=style&index=0&id=c2f75bf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f75bf8",
  null
  
)

export default component.exports